import React, { useState, useEffect, useImperativeHandle, forwardRef, useRef } from 'react'
import { useParams, generatePath } from 'react-router-dom'
import { Container, Row, Col, Card, Form, InputGroup, Tooltip, OverlayTrigger } from 'react-bootstrap'
import { Check2, X } from 'react-bootstrap-icons'
import { MathjaxContentWrapper, MathjaxContent, MathjaxCollapsible } from 'component/Util'

import { API, Router, copyUrlToClipboard } from 'app'
import { BackCrumbs, useDataLoader, ConfirmActionButton, ActionCycleButton } from 'component/Util'

const TestTimer = forwardRef((props, ref) => {
    const [timeLeft, setTimeLeft] = useState(0)
    const [timeTotal, setTimeTotal] = useState(0)
    const timerId = useRef(null)

    useImperativeHandle(ref, () => ({
        set(left, total) {
            setTimeLeft(left)
            setTimeTotal(total)
        },
        start() {
            if (timerId.current) return
            timerId.current = setInterval(() => {
                setTimeLeft(prev => {
                    if (prev <= 0) {
                        clearInterval(timerId.current)
                        timerId.current = null
                        props.actions.timeoutClock()
                        return 0
                    }
                    return prev - 1
                })
            }, 1000)
        },
        stop() {
            clearInterval(timerId.current)
            timerId.current = null
        }
    }))
    // convert to mm:ss 
    const formatTime = (time) => {
        // round down to nearest second
        time = Math.floor(time)
        const minutes = Math.floor(time / 60)
        const seconds = time % 60
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`
    }
    // return <div>Total duration: {formatTime(timeTotal)} <br /> <b>Time left: {formatTime(timeLeft)}</b></div>
    return <>Time left: <b>{formatTime(timeLeft)}</b></>
})

const TeststatusText = (props) => {
    const classes = {
        'NOT_STARTED': 'text-muted',
        'RUNNING': 'text-primary',
        'COMPLETED': 'text-success',
        'TIMED_OUT': 'text-warning',
        'CANCELLED': 'text-danger',
    }
    return <b className={`${classes[props.status]}`}>{props.status}</b>
}
const TeststatusBar = (props) => {
    const testsession = props.testsession
    const status = testsession.status
    const actions = props.actions
    const actionsMenu = () => {
        switch (status) {
            case 'NOT_STARTED':
                return <>
                    <ConfirmActionButton
                        size="sm" variant="success"
                        label="Start test"
                        modalTitle="Start Test"
                        modalBody="Are you ready to start the test now?"
                        yesVariant="success"
                        yesLabel="Start"
                        noVariant="secondary"
                        noLabel="Cancel"
                        onConfirm={actions.startTest} />&nbsp;
                    {/* <ConfirmActionButton
                        size="sm" variant="danger"
                        label="Cancel test"
                        modalTitle="Cancel Test"
                        modalBody="Do you really want to cancel the test session?"
                        yesVariant="danger"
                        yesLabel="Cancel"
                        noVariant="secondary"
                        noLabel="Back"
                        onConfirm={actions.cancelTest} /> */}
                </>
                break
            case 'RUNNING':
                return <>
                    <ConfirmActionButton
                        size="sm" variant="warning"
                        label="Finish test"
                        modalTitle="Finish Test"
                        modalBody="Are you ready to submit the test for evaluation?"
                        yesVariant="warning"
                        yesLabel="Submit"
                        noVariant="secondary"
                        noLabel="Cancel"
                        onConfirm={actions.finishTest} />&nbsp;
                    <ActionCycleButton
                        ref={props.saveBtnRef}
                        tooltipMessage="Responses are autosaved"
                        labels={{ 'CLEAN': 'Saved', 'DIRTY': 'Autosaving..', 'LOADING': 'Saving..', 'SUCCESS': 'Saved', 'ERROR': 'Error, try again' }}
                        action={actions.saveResponses}
                    />&nbsp;
                    {/* <ConfirmActionButton
                        size="sm" variant="danger"
                        label="Cancel test"
                        modalTitle="Cancel Test"
                        modalBody="Do you really want to cancel the test session?"
                        yesVariant="danger"
                        yesLabel="Cancel"
                        noVariant="secondary"
                        noLabel="Back"
                        onConfirm={actions.cancelTest} /> */}
                </>
                break
            case 'COMPLETED':
            case 'TIMED_OUT':
                return <>
                    <b style={{ fontSize: '1.1em' }}>Total score: {testsession.evals.results.total_points} / {testsession.evals.results.max_points}</b><br />
                    <BackCrumbs path={generatePath(Router.routes.COURSE_VIEW.path, { course_name: testsession.course_name })} msg='Back to course' />
                </>
                break
            case 'CANCELLED':
                return <BackCrumbs path={generatePath(Router.routes.COURSE_VIEW.path, { course_name: testsession.course_name })} msg='Back to course' />
                break
            default:
                return <></>
        }
    }
    const testHandle = <span onClick={copyUrlToClipboard} style={{ cursor: 'pointer', textDecoration: 'underline', color: '#468' }}
        title="Click to copy page URL"
    >
        Test #{testsession.handle}
    </span>
    return <div style={{ position: 'sticky', top: '55px', zIndex: 520, background: '#EEEEEE', padding: '5px' }}>
        <Row className="align-items-center">
            <Col xs={12} sm={6} lg={4} style={{ textAlign: 'left', paddingLeft: '20px' }}>{actionsMenu()}</Col>
            <Col xs={12} sm={6} lg={4} style={{ textAlign: 'center' }}>
                <pre style={{ margin: 0 }}>
                    {testHandle}: <TeststatusText status={status} /><br />
                    <TestTimer ref={props.timerRef} actions={props.actions} />
                </pre>
            </Col>
            <Col lg={4} style={{ textAlign: 'center' }}></Col>
        </Row>
    </div>
}

const Testproblem = (props) => {
    // style input field border
    const [borderStyle, setBorderStyle] = useState('2px solid darkred')
    const inputRef = useRef(null)
    const updateBorder = () => {
        if (!inputRef.current) return
        const value = inputRef.current.value
        setBorderStyle(value.trim() === '' ? '2px solid darkred' : '')
    }
    const handleChange = () => {
        if (!inputRef.current) return
        var value = inputRef.current.value
        // ToDo: this assumes responses_type = twoDigits
        if (value.trim() === "") {
            value = null
        } else if ((Number.isInteger(parseInt(value)) && value >= 0 && value <= 99)) {
            value = parseInt(value)
        } else {
            return
        }
        if (value == props.response) { return }
        updateBorder()
        props.storeResponse(props.index, value)
    }
    useEffect(() => {
        updateBorder()
    }, [props.response])

    const [correct, setCorrect] = useState(false)
    const scoreColor = correct ? 'green' : 'red'
    useEffect(() => {
        setCorrect(props.eval?.scored_points == props.eval?.max_points)
    }, [props.eval ?? null])

    const renderTooltip = (props) => (
        <Tooltip {...props} style={{ ...props.style, zIndex: 510 }}>Enter a number from 0 to 99</Tooltip>
    )
    return <Card style={{ marginBottom: '1rem' }}>
        <Card.Body>
            <Container>
                <Row>
                    <Col><b>Q {(props.index + 1)}</b>:&nbsp;
                        <MathjaxContent content={props.problem.question}></MathjaxContent>
                    </Col>
                </Row>
                <Form>
                    <Row className='align-items-center'>
                        {props.mode == 'solve' &&
                            <Col xs="auto">
                                <InputGroup size="sm" className="mb-2">
                                    <InputGroup.Text>Your answer: </InputGroup.Text>
                                    <OverlayTrigger placement='right' overlay={renderTooltip} trigger={['focus']}>
                                        <Form.Control type="text" placeholder="??" value={props.response ?? ""} maxLength={2} onChange={handleChange}
                                            ref={inputRef} style={{ maxWidth: '6ch', textAlign: 'center', border: borderStyle }} />
                                    </OverlayTrigger>
                                </InputGroup></Col>}
                        {props.mode == 'eval' &&
                            <>
                                <Col xs="auto">
                                    <InputGroup size="sm" className="mb-2">
                                        <InputGroup.Text>Your answer: </InputGroup.Text>
                                        <Form.Control type="text" placeholder="??" value={props.response ?? ""} maxLength={2} disabled style={{ maxWidth: '6ch', textAlign: 'center' }} />
                                        <InputGroup.Text style={{ background: scoreColor, fontSize: '1.2rem' }}>{correct ? <Check2 color="white" /> : <X color="white" />}</InputGroup.Text>
                                    </InputGroup>
                                </Col>
                                <Col xs="auto">
                                    <InputGroup size="sm" className="mb-2">
                                        <InputGroup.Text>Correct answer: </InputGroup.Text>
                                        <Form.Control type="text" placeholder="??" value={props.eval.answer} maxLength={2} disabled style={{ maxWidth: '6ch', textAlign: 'center' }} />
                                    </InputGroup>
                                </Col>
                                <Col xs="auto">
                                    <InputGroup size="sm" className="mb-2">
                                        <InputGroup.Text>Score: </InputGroup.Text>
                                        <Form.Control type="text" defaultValue={`${props.eval.scored_points} / ${props.eval.max_points}`} maxLength={2} disabled style={{ maxWidth: '6ch', textAlign: 'center', fontWeight: 'bold', color: scoreColor }} />
                                    </InputGroup>
                                </Col>
                            </>}
                    </Row>
                </Form>
                {props.mode == 'eval' &&
                    <>
                        {props.eval.hints.hints.length > 0 && <>
                            {props.eval.hints.hints.map((hint, index) => (
                                <MathjaxCollapsible key={index} label={`Hint ${index + 1}`} content={hint} />
                            ))}
                        </>}
                        <MathjaxCollapsible label="Solution" content={props.eval.solution} />                        
                        {props.eval.remarks && <MathjaxCollapsible label="Remarks" content={props.eval.remarks} />}
                    </>}
            </Container>
        </Card.Body>
    </Card>
}

const SectionContents = (props) => {
    return <>
        {props.section.title && <h5>{props.section.title}</h5>}
        {props.section.instructions && <MathjaxContent content={props.section.instructions} />}
        {Array.from({ length: props.section.end - props.section.start }, (_, i) => i + props.section.start).map((idx) =>
            <Testproblem key={idx} index={idx} problem={props.problems.data[idx]} response={props.responses?.[idx]} mode={props.mode} storeResponse={props.storeResponse} eval={props.evals?.data[idx]} />
        )}
        <hr />
    </>
}

// Note that the original testsession.responses data is valid only when loading the page from the server 
// It does not reflect subsequent user-side updates; to avoid re-rendering the whole TestsessionView
const Testcontents = forwardRef((props, ref) => {
    const [responses, setResponses] = useState(null)
    const testsession = props.testsession

    useEffect(() => {
        setResponses(testsession.responses?.data)
    }, [testsession.responses])
    useImperativeHandle(ref, () => ({
        getResponses() {
            return responses
        },
    }))
    const storeResponse = (idx, value) => {
        var newResponses = [...(responses || [])]
        newResponses[idx] = value
        setResponses(newResponses)
        props.actions.markResponsesDirty()
    }
    switch (testsession.status) {
        case 'NOT_STARTED':
            return <pre style={{ textAlign: "center" }}>Questions will appear here after starting the test</pre>
        case 'RUNNING':
            return <>
                {testsession.props.sections.map((section, idx) => <SectionContents key={idx} section={section} problems={testsession.problems} mode='solve' responses={responses} storeResponse={storeResponse} />)}
            </>
        case 'COMPLETED':
        case 'TIMED_OUT':
            return <>
                {testsession.props.sections.map((section, idx) => <SectionContents key={idx} section={section} problems={testsession.problems} mode='eval' responses={responses} evals={testsession.evals} />)}
            </>
        case 'CANCELLED':
            return <pre style={{ textAlign: "center" }}>Test was cancelled by the user</pre>
    }
})

export const TestsessionView = () => {
    const params = useParams()
    const handle = params.handle
    const callApi = API.useAPI()
    const testsessionLoader = useDataLoader()

    const timerRef = useRef()
    const timerSet = (left, total) => timerRef.current.set(left, total)
    const timerStart = () => timerRef.current.start()

    const saveBtnRef = useRef()
    const saveBtnClean = () => saveBtnRef.current?.setClean?.()
    const saveBtnDirty = () => saveBtnRef.current?.setDirty?.()
    const saveBtnRun = () => saveBtnRef.current?.run?.()
    const saveBtnState = () => saveBtnRef.current?.getState?.()
    const autosaveId = useRef(null)

    const contentsRef = useRef()
    const contentsGetResponses = () => contentsRef.current?.getResponses?.()

    const clearAutosave = () => {
        if (autosaveId.current) {
            clearTimeout(autosaveId.current)
            autosaveId.current = null
        }
    }
    const actions = {
        startTest: async () => {
            try {
                await testsessionLoader.fetch(API.endpoints.TESTSESSION_UPDATE, { handle, new_status: 'RUNNING' })
            } catch { return }
        },
        markResponsesDirty: async () => {
            saveBtnDirty()
            clearAutosave()
            autosaveId.current = setTimeout(saveBtnRun, 1000)
        },
        saveResponses: async () => {
            try {
                clearAutosave()
                await callApi(API.endpoints.TESTSESSION_SAVE, { handle, responses: { data: contentsGetResponses() } })
            } catch { return }
        },
        finishTest: async () => {
            try {
                await callApi(API.endpoints.TESTSESSION_SAVE, { handle, responses: { data: contentsGetResponses() } })
                await testsessionLoader.fetch(API.endpoints.TESTSESSION_UPDATE, { handle, new_status: 'COMPLETED' })
            } catch { return }
        },
        cancelTest: async () => {
            try {
                await testsessionLoader.fetch(API.endpoints.TESTSESSION_UPDATE, { handle, new_status: 'CANCELLED' })
            } catch { return }
        },
        timeoutClock: async () => {
            try {
                await testsessionLoader.fetch(API.endpoints.TESTSESSION_UPDATE, { handle, new_status: 'TIMED_OUT' })
            } catch { return }
        }
    }
    useEffect(() => {
        try {
            const { testsession } = testsessionLoader.get()
            if (testsession.status == 'NOT_STARTED') {
                timerSet(testsession.props.duration, testsession.props.duration)
            } else if (testsession.status == 'RUNNING') {
                const curTime = new Date(testsession.current_time)
                const startTime = new Date(testsession.started_on)
                const elapsed = (curTime.getTime() - startTime.getTime()) / 1000.0
                timerSet(testsession.props.duration - elapsed, testsession.props.duration)
            } else if (testsession.status == 'COMPLETED') {
                const finishTime = new Date(testsession.finished_on)
                const startTime = new Date(testsession.started_on)
                const elapsed = (finishTime.getTime() - startTime.getTime()) / 1000.0
                timerSet(testsession.props.duration - elapsed, testsession.props.duration)
            } else if (testsession.status == 'TIMED_OUT') {
                timerSet(0, testsession.props.duration)
            }
            if (testsession.status == 'RUNNING') {
                timerStart()
            }
        } catch { return }
    }, [testsessionLoader.data])
    const reloadData = async () => {
        await testsessionLoader.fetch(API.endpoints.TESTSESSION_VIEW, { handle })
    }
    useEffect(() => void reloadData(), [])
    return <MathjaxContentWrapper>
        {testsessionLoader.view((data) =>
            <>
                <TeststatusBar testsession={data.testsession} actions={actions} timerRef={timerRef} saveBtnRef={saveBtnRef}></TeststatusBar>
                {
                    data.testsession.props.test_instructions &&
                    <>
                        <h4>Instructions</h4>
                        <div dangerouslySetInnerHTML={{ __html: data.testsession.props.test_instructions }} />
                    </>
                }
                < hr />
                <Testcontents testsession={data.testsession} actions={actions} ref={contentsRef}></Testcontents>
            </>
        )}
    </MathjaxContentWrapper>
}
